/* unplugin-vue-components disabled */import { render } from "./md-table.vue?vue&type=template&id=129e5a84&scoped=true"
import script from "./md-table.vue?vue&type=script&lang=js"
export * from "./md-table.vue?vue&type=script&lang=js"

import "./md-table.vue?vue&type=style&index=0&id=129e5a84&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129e5a84"],['__file',"src/components/md-content/md-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "129e5a84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('129e5a84', __exports__)) {
    api.reload('129e5a84', __exports__)
  }
  
  module.hot.accept("./md-table.vue?vue&type=template&id=129e5a84&scoped=true", () => {
    api.rerender('129e5a84', render)
  })

}


export default __exports__